export default {
  retailerId: "Customer",
  billingLocation: "Bill To",
  shippingLocationId: "Ship To",
  purchaseOrder: "PO #",
  originalOrderNumber: false, //"Original #",
  status: "Status",
  email: "Email Confirmation",
  type: "Order Type",
  sourceId: "Order Source",
  showCode: "Show Code",
  showVendorLocation: "Show Vendor Location",
  paymentTermsId: "Terms",
  priceList: "Price List",
  vendorId: "Vendor",
  buyer: "Contact/Buyer",
  shippingMethodId: "Ship Via",
  shipOn: "Ship Date",
  hideCheckoutShipOn: false,
  cancelOn: "Cancel Date",
  orderedOn: "Order Date",
  expectedToClear: "Expected To Clear",
  note: "Note",
  vendorNote: false,
  deliveryNote: false,
  shippingNote: false,
  tagFor: false,
  cartName: "Order Name",
  discount: "Discount",
  warehouse: false,
  container: false,
  // line
  availableOn: false,
  lineNote: "Note",
  orderNote: "Note",
  lineDiscount: "",
  lineVendorId: false,
  reasonCode: false,
  priceOverride: false,
  listPrice: "List Price",
  caseQty: "Case Qty",
  SaveOrderLabel: "Save",
  SavingOrderLabel: "Saving...",
  StartOrderLabel: "Start Order",
  StartingOrderLabel: "Starting Order...",
  creditHoldLabel: "credit hold",
  // parts order
  acknowledgement: "Acknowledgement",
  customerServiceEmail: "Customer Service Email(s)",
  comments: "Comments",
  invoiceId: "Original Invoice #",
  contactName: "Contact Name",
  // change notice
  orderNumber: "Order",
  productId: "SKU",
  changedOn: "Change Date",
  previousAvailableOn: "Prev Avail Date",
  currentAvailbleOn: "New Avail Date",
  deliveryTypes: false,
  upc: false,
  // actions
  closeOrder: false,
  // icons
  prevOrder: false,
  nextOrder: false,
};
